<mat-form-field appearance="outline" class="combined-picker">
    <mat-label>{{ label }}</mat-label>
  
    <input matInput [value]="displayValue" readonly>
  
    <button mat-icon-button matSuffix (click)="datePicker.open()" aria-label="Open date picker">
      <mat-icon>event</mat-icon>
    </button>
  
    <button mat-icon-button matSuffix (click)="timePicker.open()" aria-label="Open time picker">
      <mat-icon>access_time</mat-icon>
    </button>
  
    <input matInput [matDatepicker]="datePicker" [(ngModel)]="selectedDate" (dateChange)="emitCombinedDateTime()" hidden>
    <mat-datepicker #datePicker></mat-datepicker>
  
    <input matInput [ngxMatTimepicker]="timePicker" [(ngModel)]="selectedTime" (ngModelChange)="emitCombinedDateTime()" hidden>
    <ngx-mat-timepicker #timePicker></ngx-mat-timepicker>
  </mat-form-field>